export default [
  {
    path: "/LayoutTemplate/car/LayoutFound3",
    name: "car_LayoutFound3",
    meta: {
      title: "汽车信息",
      requiresAuth: 1
    },
    component: () => import("@/views/car/LayoutFound3.vue"),
    children: [{
      path: "/t12",
      name: "t12",
      meta: {
        title: "查看汽车",
        requiresAuth: 1
      },
      component: () => import("@/views/car/components/t12/index.vue")
    },
    {
      path: "/xxhx",
      name: "xxhx",
      meta: {
        title: "线下核销",
        requiresAuth: 1
      },
      component: () => import("@/views/car/xxhx.vue")
    },
    {
      path: "/car/carParams",
      name: "car_carParams",
      meta: {
        title: "汽车参数",
        requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
      },
      component: () => import("@/views/car/subpages/carParams.vue")
    },{
      path: "/car/carDetect",
      name: "car_carDetect",
      meta: {
        title: "检测报告",
        requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
      },
      component: () => import("@/views/car/subpages/carDetect.vue")
    }]
  },
  {
    path: "/LayoutTemplate/car/LayoutFound4",
    name: "car_LayoutFound4",
    meta: {
      title: "港鑫汽车",
      requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
    },
    component: () => import("@/views/car/LayoutFound4.vue"),
    children: [{
      path: "/t13",
      name: "t13",
      meta: {
        title: "港鑫精品二手车",
        requiresAuth: 0 // location.href.indexOf("noguide=1") > -1 ? 0 : 1
      },
      component: () => import("@/views/car/components/t13/index.vue")
    }]
  },
  {
    path: "/LayoutTemplate/car/LayoutDefault",
    name: "car_LayoutDefault",
    meta: {
      title: "港鑫汽车",
      requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
    },
    component: () => import("@/views/car/LayoutDefault.vue"),
    children: [{
      path: "/profile/favorite",
      name: "car_favorite",
      meta: {
        title: "我的收藏",
        requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
      },
      component: () => import("@/views/car/subpages/favorite.vue")
    },
    {
      path: "/profile/reserve",
      name: "car_reserve",
      meta: {
        title: "我的约看",
        requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
      },
      component: () => import("@/views/car/subpages/reserve.vue")
    },
    {
      path: "/profile/bought",
      name: "car_bought",
      meta: {
        title: "我买的车",
        requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
      },
      component: () => import("@/views/car/subpages/bought.vue")
    },
    {
      path: "/profile/sold",
      name: "car_sold",
      meta: {
        title: "我卖的车",
        requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
      },
      component: () => import("@/views/car/subpages/sold.vue")
    },
    {
      path: "/profile/ticket",
      name: "car_ticket",
      meta: {
        title: "我的优惠券",
        requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
      },
      component: () => import("@/views/car/subpages/ticket.vue")
    },
    {
      path: "/car/findCar",
      name: "car_findCar",
      meta: {
        title: "帮你找车",
        requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
      },
      component: () => import("@/views/car/subpages/findCar.vue")
    },
    {
      path: "/car/redpack",
      name: "car_redpack",
      meta: {
        title: "购车红包",
        requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
      },
      component: () => import("@/views/car/subpages/redpack.vue")
    },
    {
      path: "/car/process",
      name: "car_process",
      meta: {
        title: "购车流程",
        requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
      },
      component: () => import("@/views/car/subpages/process.vue")
    },
    {
      path: "/car/quality",
      name: "car_quality",
      meta: {
        title: "质量保障",
        requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
      },
      component: () => import("@/views/car/subpages/quality.vue")
    },
    {
      path: "/car/search",
      name: "car_search",
      meta: {
        title: "搜索汽车",
        requiresAuth: location.href.indexOf("noguide=1") > -1 ? 0 : 1
      },
      component: () => import("@/views/car/subpages/search.vue")
    }
    ]
  }
]